<script setup lang="ts">
import Cms from "@/components/Cms.vue";
import { ref, computed } from "vue";
// import { registeredComponents } from "@root/cms-page-init.ts";
import { getBuilderComponents } from "@root/builder-components.ts";
import { Head } from "@inertiajs/vue3";
let builderData = ref({
    pageName: ""
});
let pageName = computed(()=>{
    return props.cmsContent.data.pageName ?? builderData.value.pageName;
})

let metaDescription = computed(()=>{
    return props.cmsContent.data.metaDescription ?? builderData.value.metaDescription;
})

let metaKeywords = computed(()=>{
    return props.cmsContent.data.metaKeywords ?? builderData.value.metaKeywords;
})
let searchParams = computed(()=>{
    return {
        "data.pageUrl.$eq": `/customer-service/cms/${props.currentView}`
    };
})

let props = defineProps({
    cmsContent: {
        type: Object,
        default: () => ({
            data: {
                pageName: null,
                metaDescription: "",
                metaKeywords: ""
            }
        })
    },
    currentView: {
        type: String,
        default: "default"
    }
})
</script>
<template>
    <div>
        <Head>
            <title>{{ pageName }}</title>
            <meta name="description" :content="metaDescription" />
            <meta name="keywords" :content="metaKeywords" />
        </Head>
        <h1 class="headline-xl">{{ pageName }}</h1>
        <cms v-model="builderData" content-prop="cmsContent" model="content-section" driver="builder" :readable-fields="['pageName', 'metaDescription', 'metaKeywords']" :components="getBuilderComponents()" is-section :search-params="searchParams"/>
    </div>
</template>